import { SEARCH_MEDIA } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SEARCH_MEDIA.LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_MEDIA.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SEARCH_MEDIA.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case SEARCH_MEDIA.CLEAR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
}
